export default __webpack_public_path__ + "locales/en/Webhooks.json?hash=10fd46e929dc1c6069984229e08a2e1e";